import { ThemeColorPalette } from '../types';

export const DEFAULT_THEME_COLORS: ThemeColorPalette = {
  PRIMARY: '#28503C',
  PRIMARY_e0f5f2: '#e0f5f2',
  PRIMARY_DARK: '#1E5546',
  SECONDARY: '#1F6E63',
  SECONDARY_300: '#307266',
  WHITE: '#FFFFFF',
  WHITE_200: '#E2E8F0',
  WHITE_300: '#F8FAFC',
  WHITE_400: '#D9D9D9',
  WHITE_EEE: '#eee',
  WHITE_FDFDFD: '#FDFDFD',
  WHITE_800: '#F5F8FB',
  WHITE_900: '#FAFAFA',
  BLACK: '#000000',
  BLACK_100: '#121212',
  BLACK_444: '#444',
  BLACK_373737: '#373737',
  BLACK_222: '#222',
  BLACK_0D: '#0000000D',
  BLACK_14: '#00000014',
  BLACK_30726633: '#30726633',
  BLACK_555555: '#555555',
  BLACK_24253D: '#24253D',
  GREY: '#989898',
  GREY_2A2A2A: '#2A2A2A',
  GREY_505050: '#505050',
  DARK_GREY: '#696969',
  GRAY_100: '#333333',
  GRAY_300: '#CCCCCC',
  GRAY_374151: '#374151',
  GRAY_4C4C4C: '#4C4C4C',
  GRAY_505050: '#505050',
  GRAY_600: '#6B7280',
  GRAY_666: '#666',
  GRAY_757575: '#757575',
  GRAY_777777: '#777777',
  GRAY_800: '#8E9196',
  GRAY_8E8E8E: '#8E8E8E',
  GRAY_9D9D9D: '#9D9D9D',
  GRAY_A1A1AA: '#A1A1AA',
  GRAY_AFAFAF1A: '#AFAFAF1A',
  GRAY_B8B8B8: '#B8B8B8',
  GRAY_C4C4C4: '#C4C4C4',
  GRAY_D1D1D1: '#D1D1D1',
  GRAY_D3D3D3: '#D3D3D3',
  GRAY_D4D4D4: '#D4D4D4',
  GRAY_D8D8D8: '#D8D8D8',
  GRAY_DDD: '#ddd',
  GRAY_E8E8E8: '#E8E8E8',
  GRAY_E9E9E9: '#E9E9E9',
  GRAY_ECECEC: '#ECECEC',
  GREEN_007B64: '#007b64',
  GREEN_4CAF50: '#4CAF50',
  BLUE_200: '#44C7B3',
  BLUE_00796B: '#00796B',
  BLUE_11B5AE66: '#11B5AE66',
  BLUE_1976D2: '#1976D2',
  BLUE_2196F3: '#2196F3',
  BLUE_2C7D6B: '#2C7D6B',
  BLUE_2E4E9D: '#2E4E9D',
  BLUE_32344C: '#32344c',
  BLUE_3629B7: '#3629B7',
  BLUE_42C7B1: '#42c7b1',
  BLUE_4A9B8E: '#4a9b8e',
  BLUE_83D0BF: '#83d0bf',
  BLUE_87CEEB: '#87CEEB',
  BOTTOMTAB_ACTIVE: '#C2691B',
  ACCENT: '#C2691B',
  RED: '#EF4444',
  RED_FF3D00: '#FF3D00',
  RED_FF474C: '#FF474C',
  GOLD: '#FFD700',
  GOLD_FACC15: '#FACC15',
  GOLD_FFC107: '#FFC107',
  GOLD_FFAD08: '#FFAD08',
  CREAME_WHITE: '#F7F2E8',
  BACKGROUND_WHITE: '#F7F2E8',
  BEIGE: '#F5EBD9',
  MIRAGE: '#151C2A',
  LIGHT_BLACK: '#343434',
  TRANSPARENT: 'transparent',
};

export const mergeThemeColors = (
  overrides: ThemeColorPalette = {}
): ThemeColorPalette => ({
  ...DEFAULT_THEME_COLORS,
  ...overrides,
});

